import { __t } from '../../i18n/t'

// NumberInput vazio guarda null (não undefined); com `!== undefined` o null passava
// e a conta do teto dava 1 em vez de ficar de fora.
export const validateDrawingNumbers = (values: { startNumber?: number | null; endNumber?: number | null }) => {
  const errors: { endNumber?: string } = {}
  if (values.startNumber != null && values.endNumber != null) {
    const total = values.endNumber - values.startNumber + 1
    if (total > 10_000_000) {
      errors.endNumber = __t('O limite máximo é de 10.000.000 de números da sorte')
    }
  }
  return errors
}
